import Vue from "vue";

export default {
  methods: {
    mix__openNotification (title, text, status = 'success') {
      Vue.prototype.$notify({
        type: status,
        title: title,
        customClass: 'nooooty',
        dangerouslyUseHTMLString: true,
        message: text
      })
    }
  }
}
